<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />


    <div v-show="!modoVisualizacao">
        <div class="form-edit-page row-space">
            <div class="row-start">
                <div class="form-item-char40"><GabineteDepartamentoSelect v-model:departamentoSelecionado="idDepartamento"/></div>
                <div class="form-item-char20"><GabineteAgendaStatusSelect :ckAddTodos="true" v-model:opcaoSelecionada="idStatus" /></div>
                <div class="form-item-rangedata"><DateRangeSelect :labelPeriodo="'Período prazo'" v-model="dateRange" /></div>
                <button class="btn-small" @click="lerDados">Listar</button>
                <button class="btn-small" @click="closeForm">Retornar</button>
            </div>
        </div>
        
        <div v-if="lsDados.length>0" class="table-wrapper"><table>
            <thead>
                <tr>
                    <th>Nome</th>
                    <th>Solicitação</th>
                    <th>Departamento</th>
                    <th>Data</th>
                    <th>Prazo</th>
                    <th>Dias</th>
                    <th>Situação</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"  
                    @click="setVisualizar(obj)">
                    <td class="col-width-char40">{{ obj.nmpessoa }}</td>
                    <td>{{ obj.solicitacao }}</td>
                    <td class="col-width-char30">{{ obj.nmdepartamento }}</td>
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtsolicitacao) }}</td>
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtprazo) }}</td>
                    <td class="col-width-char05 center" :class="{ 'td-alert': obj.ttdias_aguardando < 0 }">
                        {{ Funcoes.formatInteger(obj.ttdias_aguardando) }}</td>
                    <td class="col-width-char15" :class="{ 'td-alert': obj.ttdias_aguardando < 0 }">
                        {{ obj.nmstatus }}</td>
                </tr>
            </tbody>
        </table></div><div v-else><h3>NENHUMA SOLICITAÇÃO LOCALIZADA</h3></div>
        

        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>



    <div v-if="modoVisualizacao">
        <GabRequisicaoViewPage :idView="idView" @close="modoVisualizacao = false" @save="lerDados()" />
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericPost } from '@/funcoes/api'; 
import { globalStore } from '@/globals';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import GabineteAgendaStatusSelect from '@/selects/estaticos/GabineteAgendaStatusSelect.vue';
import GabineteDepartamentoSelect from '@/selects/GabineteDepartamentoSelect.vue';
import GabRequisicaoViewPage from './GabRequisicaoViewPage.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close']);

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const msgAlerta = ref(null);
const idDepartamento = ref(0);
const idStatus = ref(0);
const idView = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const lsDadosMain = ref([]);
const modoVisualizacao = ref(false);
const showPagination = ref(false);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);

const closeForm = () => {emit('close');}


async function lerDados() {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await genericPost('/listas/gabinete_agenda_req', {
            idmunicipio: globalStore.idmunicipio,
            idpessoa: 0,
            intparam1: idStatus.value,
            intparam2: idDepartamento.value,
            datainicial: dateRange.value.startDate, 
            datafinal:dateRange.value.endDate});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}


const setVisualizar = (obj) =>{
    idView.value = obj.id;
    modoVisualizacao.value = true;
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(lerDados);
</script>
